import { Box } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import BrandHeaders from "src/components/BrandHeaders";
import Footer from "src/components/Footer";
import PostHogAnalytics from "src/components/PostHogAnalytics";
import { useNativeWebViewInsets } from "src/context/NativeWebViewInsetsContext";
import { ThemeContext } from "./ThemeContext";

const SMSP_ICON_URL =
  "https://storage.googleapis.com/strongmsp-media/media/organization_logos/smsp_icon_blue_fCvN3ww.png";
const SMSP_ICON_DARK_URL =
  "https://storage.googleapis.com/strongmsp-media/media/organization_logos/smsp_icon_white_sMfBfNj.png";

const Layout: React.FC = () => {
  const location = useLocation();
  const { darkMode } = React.useContext(ThemeContext);
  const nativeInsets = useNativeWebViewInsets();
  const [snack, showSnackBar] = React.useState("");

  const closeSnackbar = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    showSnackBar("");
  };

  function formatPathnameToDocTitle(pathname: string) {
    // Remove leading and trailing slashes, then split by remaining slashes
    const segments = pathname.replace(/^\/|\/$/g, "").split("/");

    // Capitalize each segment
    const capitalizedSegments = segments.map(segment => {
      if (!segment) return "";
      return segment.charAt(0).toUpperCase() + segment.slice(1);
    });

    // Reverse the order and join with spaces
    return capitalizedSegments.reverse().join(" ").trim();
  }

  useEffect(() => {
    document.title = formatPathnameToDocTitle(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    const id = requestAnimationFrame(() => {
      if (typeof window !== 'undefined') window.scrollTo(0, 0);
    });
    return () => cancelAnimationFrame(id);
  }, [location.pathname]);

  return (
    <React.Fragment>
      <PostHogAnalytics />
      <Snackbar
        open={snack.length > 0}
        autoHideDuration={5000}
        onClose={closeSnackbar}
        message={snack}
      />

      <main style={{ position: 'relative' }}>
        <BrandHeaders />

        <Box
          id="layout-container"
          style={{
            position: 'relative',
            zIndex: 20,
            minHeight: 'calc(100vh - 100px)',
            ...(nativeInsets.isNativeWebView
              ? {
                paddingLeft: nativeInsets.paddingLeft > 0 ? `${nativeInsets.paddingLeft}px` : undefined,
                paddingRight: nativeInsets.paddingRight > 0 ? `${nativeInsets.paddingRight}px` : undefined,
              }
              : {}),
          }}
        >
          <Outlet />
        </Box>

        <div id="logo-watermark"
          style={{
            position: 'fixed',
            filter: 'grayscale(100%)',
            pointerEvents: 'none',
            zIndex: 0, top: '-5%', left: '-8%',
            width: '110%', height: '100%', opacity: 0.02
          }}>
          <img
            src={darkMode ? SMSP_ICON_DARK_URL : SMSP_ICON_URL}
            alt=""
            aria-hidden
            style={{
              height: `${window.innerHeight * 1.2}px`,
              maxWidth: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
        <Footer />
      </main>


    </React.Fragment>
  );
};

export default Layout;
